import { render } from "./TermsOfUserView.vue?vue&type=template&id=4e7f07f8&ts=true"
import script from "./TermsOfUserView.vue?vue&type=script&lang=ts"
export * from "./TermsOfUserView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__